import { useFormikContext ,getIn} from 'formik';
import React, { useState, useEffect } from 'react';
import { FormLabel } from './FormLabel';

import { Button } from "reactstrap"
import { useEdit } from '../../Services/EditContext';
import ErrorMessage from './ErrorMessage'
import LoadingAnimation from './LoadingAnimation';
import Selector from './Selector';
import CompareFormValue from './CompareFormValue';
import { useFetchCached } from '../../Services/fetchApi';


const SelectSetting = ({ string , id, label, endpoint,noEdit, onChange ,value}) => {
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState([]);
    const fc = useFormikContext();
    const setFieldValue = fc?.setFieldValue;
    const values = fc?.values;

    const editar = useEdit();

    const edit = editar.length ? editar[0]:true;
    const [currencies, loading, error, refresh] = useFetchCached(endpoint);
    const val = value?value:getIn(values, id);


    useEffect(() => {
        if (currencies instanceof Array) {
            const options = currencies.map(x => { return string ? {label:x, value:x}:{ label: x.value, value: x.value}; });
            setOptions(options);
        }
    }, [currencies, string]);
    useEffect(() => {
        if (options && val) {

            const list = val.split(',');
            const newOps = list.map(x => options.find(y => x === y.value));
            setSelection(newOps)
        }
    }, [val, options,string])

    const onSelectChange = val => {
        onChange ? onChange(val.value) : setFieldValue && setFieldValue(id, val.value)

    }
    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {edit && !noEdit ? <Selector onChange={onSelectChange} value={selection} options={options} /> : <CompareFormValue id={id}/>}
        {loading ? <LoadingAnimation height={'50px'}/> : error ? <h3>Error<Button from onClick={refresh}>Retry</Button></h3> : null}
        {fc? <ErrorMessage name={id} />:null}
    </React.Fragment>
};

export default SelectSetting;